import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';
import { ChevronRight } from 'lucide-react';

const CAT_EMOJI = {
  'vhill 32k': '🔥', 'vhill32k': '🔥',
  'vhill 12k': '👾', 'vhill12k': '👾',
  'vhill 3k': '⚡', 'vhill3k': '⚡',
  'vhill 0% nic': '🌿', 'vhill 0%': '🌿', 'vhill sin nicotina': '🌿',
  'vape desechable': '💨', 'desechable': '💨', 'desechables': '💨',
  'e-juice': '💧', 'ejuice': '💧', 'líquidos': '💧', 'liquidos': '💧',
  'kits': '⚡', 'kits y mods': '⚡', 'mods': '⚡',
  'pods': '🫧', 'pod': '🫧',
  'resistencias': '🔧', 'coils': '🔧',
  'accesorios': '🛠️', 'accesorio': '🛠️',
  'baterías': '🔋', 'baterias': '🔋',
  'cristales': '💎', 'vidrios': '💎',
  'nicotina': '🌿', 'sales': '🌿',
  'starter': '🎯', 'starter kit': '🎯',
  'vaporizador': '🌬️', 'vaporizadores': '🌬️',
};

const getEmoji = (name = '', customEmoji = '') => {
  if (customEmoji) return customEmoji;
  const key = name.toLowerCase().trim();
  if (CAT_EMOJI[key]) return CAT_EMOJI[key];
  for (const [k, v] of Object.entries(CAT_EMOJI)) {
    if (key.includes(k) || k.includes(key)) return v;
  }
  return '🛒';
};

const CategoriesRow = ({ title = 'Categorías', subtitle = 'Encuentra lo que buscas' }) => {
  const [cats, setCats] = useState(null); // null = loading

  useEffect(() => {
    api.get('/categories')
      .then((r) => setCats((r.data || []).filter((c) => c.visible !== false)))
      .catch(() => setCats([]));
  }, []);

  // Don't render anything until data arrives or if there are no visible categories
  if (!cats || cats.length === 0) return null;

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 mt-12">
      <div className="flex items-end justify-between mb-5">
        <div>
          <h3 className="text-2xl md:text-3xl font-black text-white">{title}</h3>
          {subtitle && <p className="text-sm text-white/50 mt-1">{subtitle}</p>}
        </div>
        <Link to="/catalogo" className="text-orange-400 hover:text-orange-300 text-sm font-semibold inline-flex items-center gap-1 shrink-0">
          Ver todo <ChevronRight className="w-4 h-4" />
        </Link>
      </div>

      <div className="flex flex-wrap gap-2.5">
        {cats.map((c) => (
          <Link
            key={c.slug}
            to={`/catalogo?cat=${encodeURIComponent(c.name)}`}
            data-testid={`category-pill-${c.slug}`}
            className="group flex items-center gap-2.5 px-4 py-2.5 rounded-full bg-neutral-900 border border-white/12 hover:border-orange-500 hover:bg-orange-500/10 transition-all duration-200"
          >
            <span className="text-lg leading-none">{getEmoji(c.name, c.emoji)}</span>
            <span className="text-sm font-semibold text-white/85 group-hover:text-white whitespace-nowrap transition-colors">
              {c.name}
            </span>
            <span className="text-[11px] font-bold text-white/35 group-hover:text-orange-400 transition-colors whitespace-nowrap">
              {c.count}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default CategoriesRow;
